import axios from 'axios';
import * as utils from '../../../utils/Utils';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';

const CancelToken = axios.CancelToken;
let fetchAccountFiltersCancelToken: any;
let fetchAccountEBPsCancelToken: any;
let fetchAccountDynamicFieldListsCancelToken: any;

export function fetchAccountFilters({
  page = 1,
  filterNames,
  filterUserId,
  filterGlobalStatuses,
  filterBrandIds,
  customFieldIds,
  orderCondition,
  descending,
}: {
  page: number;
  filterNames?: string[];
  filterUserId?: number[];
  filterGlobalStatuses?: number[];
  filterBrandIds?: number[];
  customFieldIds?: number[];
  orderCondition?: string;
  descending?: number;
}) {
  if (fetchAccountFiltersCancelToken) fetchAccountFiltersCancelToken();

  const params = utils.createURL([
    { name: 'page', values: page },
    { name: 'limit', values: utils.getPageLimit() },
    { name: 'filter_names', values: filterNames },
    { name: 'filter_user_id', values: filterUserId },
    { name: 'filter_global_statuses', values: filterGlobalStatuses },
    { name: 'filter_brand_ids', values: filterBrandIds },
    { name: 'custom_field_ids', values: customFieldIds },
    { name: 'order_condition', values: orderCondition },
    { name: 'descending', values: descending },
  ]);

  return {
    type: 'FETCH_ACCOUNT_FILTERS',
    meta: { page },
    payload: axios.get(`${getNonGwApiRoot()}/accounts/configurations/filters${params}`, {
      cancelToken: new CancelToken(c => {
        fetchAccountFiltersCancelToken = c;
      }),
    }),
  };
}

export function fetchAccountEBPs(customFieldIds?: number[]) {
  if (fetchAccountEBPsCancelToken) fetchAccountEBPsCancelToken();

  const params = utils.createURL([{ name: 'custom_field_ids', values: customFieldIds }]);

  return {
    type: 'FETCH_ACCOUNT_EBPS',
    payload: axios.get(
      `${getNonGwApiRoot()}/accounts/configurations/full_export_templates${params}`,
      {
        cancelToken: new CancelToken(c => {
          fetchAccountEBPsCancelToken = c;
        }),
      }
    ),
  };
}

export function fetchAccountDynamicFieldLists(customFieldIds?: number[]) {
  if (fetchAccountDynamicFieldListsCancelToken) fetchAccountDynamicFieldListsCancelToken();

  const params = utils.createURL([{ name: 'custom_field_ids', values: customFieldIds }]);

  return {
    type: 'FETCH_ACCOUNT_DYNAMIC_LISTS',
    payload: axios.get(
      `${getNonGwApiRoot()}/accounts/configurations/dynamic_field_lists${params}`,
      {
        cancelToken: new CancelToken(c => {
          fetchAccountDynamicFieldListsCancelToken = c;
        }),
      }
    ),
  };
}
